// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .my[data-v-01cc9236]{border:3px solid #add8e6;outline:none}.hrsata-jobs .mention[data-v-01cc9236]{border:2px solid #90ee90;outline:none;-webkit-box-shadow:0 0 10px #32cd32;box-shadow:0 0 10px #32cd32}.hrsata-jobs .comment[data-v-01cc9236]{word-wrap:break-word;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
